var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.3008 2.37015L12.3621 0.433253C12.2253 0.295893 12.0628 0.186907 11.8838 0.112555C11.7048 0.0382044 11.5128 -4.64556e-05 11.319 4.23414e-08C10.924 4.23414e-08 10.5526 0.154733 10.2741 0.433253L8.18798 2.51942C8.05063 2.65618 7.94164 2.81873 7.86729 2.99773C7.79294 3.17674 7.75469 3.36867 7.75474 3.5625C7.75474 3.95752 7.90947 4.32888 8.18798 4.6074L9.71345 6.13289C9.35637 6.91995 8.85992 7.63596 8.24806 8.24636C7.63773 8.85972 6.92179 9.35798 6.13462 9.71723L4.60916 8.19175C4.4724 8.05439 4.30985 7.9454 4.13085 7.87105C3.95185 7.7967 3.75992 7.75845 3.56609 7.7585C3.17107 7.7585 2.79972 7.91323 2.5212 8.19175L0.433247 10.2761C0.29572 10.4131 0.186642 10.576 0.112289 10.7553C0.0379356 10.9346 -0.000225577 11.1269 1.00309e-06 11.321C1.00309e-06 11.716 0.154732 12.0874 0.433247 12.3659L2.36829 14.301C2.81246 14.747 3.42592 15 4.05577 15C4.18865 15 4.31608 14.9891 4.44168 14.9672C6.89553 14.5631 9.32935 13.2579 11.2935 11.2955C13.2559 9.33495 14.5592 6.90291 14.9688 4.44175C15.0926 3.68993 14.8432 2.91626 14.3008 2.37015Z",
    fill: "#646464"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.c8b563ea283af8608cac1e5d71e1a7ed.svg";
export { ForwardRef as ReactComponent };